import React from "react";
import f from "./images/facebook.png";
import x from "./images/x.png";
import instagram from "./images/instagram.png";

function MyFooter() {
  return (
    
   <div className="bottom-section">
  <div className="container bottom-content">
    {/* Links Section */}
    <div className="bottom-column">
      <h4>Explore</h4>
      <ul>
        <li><a href="#">Home</a></li>
        <li><a href="#">About Us</a></li>
        <li><a href="#">Academics</a></li>
        <li><a href="#">Contact</a></li>
      </ul>
    </div>

    {/* Social Media Section */}
    <div className="bottom-column">
      <h4>Stay Connected</h4>
      <div className="social-links">
        <a href="#"><img src={f} alt="Facebook" /></a>
        <a href="#"><img src={x} alt="Twitter" /></a>
        <a href="#"><img src={instagram} alt="Instagram" /></a>
      </div>
    </div>
  </div>

  <div className="container bottom-bar">
    <p>&copy; 2025 University of Somalia. All rights reserved.</p>
    <div className="extra-links">
      <a href="#">Privacy Policy</a>
      <a href="#">Terms of Service</a>
    </div>
  </div>
</div>


  );
}

export default MyFooter;
